import React, { Suspense } from 'react';
import Loader from 'ui-kit/Loader';

// Lazy-load the heavy inner component so survey-react (~1.15 MB raw) and its
// CSS land in their own webpack chunk instead of polluting the main bundle
// through the modules barrel re-export chain.
const VisitEditFormInner = React.lazy(() => import('./VisitEditFormInner'));

const VisitEditForm = (props) => (
  <Suspense fallback={<Loader />}>
    <VisitEditFormInner {...props} />
  </Suspense>
);

export default VisitEditForm;
